var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.admin && _vm.admin.token)?_c('portal-cabecalho-admin'):_c('portal-cabecalho',{attrs:{"urlTrocaSenha":_vm.urlTrocaSenha}}),_vm._v(" "),_c('div',{staticClass:"page"},[_c('router-view')],1),_vm._v(" "),_c('portal-rodape')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b917ff6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = vze6
// module chunks = 0